// extracted by mini-css-extract-plugin
module.exports = {"whmaz2f":"whmaz2f","iikidyf":"iikidyf"};